import { Env } from '@app/core/interfaces/env.interface';
import { Store } from '@app/shared/modules/mobile-badge/enums/store.enum';
import { Themes } from '@app/core/enums/themes.enum';
import { EnvType } from '@app/core/enums/env-type.enum';
import { AxiomMapRegion } from '@axiom/material-components/kit/map';

export const environment: Env = {
  production: true,
  apiUrl: 'https://api.taxsee.com/client/v1',
  appName: 'maxim 🚕',
  stores: {
    [Store.AppStore]:
      'https://maxim-ios.onelink.me/IqHi?is_retargeting=true&af_web_dp=https%3A%2F%2Fapps.apple.com%2Fru%2Fapp%2Fid579985456%3Fpt%3D119057982%26ct%3Dtaximaxim_site%26mt%3D8&c=rt&pid=taximaxim_site',
    [Store.GooglePlay]:
      'https://maxim-android.onelink.me/ezSa?is_retargeting=true&af_web_dp=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dcom.taxsee.taxsee%26referrer%3Dutm_source%253Dtaximaxim%2526utm_medium%253Dsite&c=rt&pid=taximaxim_site',
    [Store.AppGallery]:
      'https://maxim-android.onelink.me/ezSa?is_retargeting=true&af_web_dp=https%3A%2F%2Fappgallery.cloud.huawei.com%2Fmarketshare%2Fapp%2FC100093035&af_r=https%3A%2F%2Fappgallery.cloud.huawei.com%2Fmarketshare%2Fapp%2FC100093035&c=rt&pid=taximaxim_site',
    [Store.GalaxyStore]:
      'https://maxim-android.onelink.me/ezSa?is_retargeting=true&af_web_dp=https%3A%2F%2Fgalaxystore.samsung.com%2Fdetail%2Fcom.taxsee.taxsee&af_r=https%3A%2F%2Fgalaxystore.samsung.com%2Fdetail%2Fcom.taxsee.taxsee&c=rt&pid=taximaxim_site',
    [Store.GetApps]:
      'https://maxim-android.onelink.me/ezSa?is_retargeting=true&af_web_dp=https%3A%2F%2Fglobal.app.mi.com%2Fdetails%3Fid%3Dcom.taxsee.taxsee&af_r=https%3A%2F%2Fglobal.app.mi.com%2Fdetails%3Fid%3Dcom.taxsee.taxsee&c=rt&pid=taximaxim_site',
    [Store.RuStore]: 'https://apps.rustore.ru/app/com.taxsee.taxsee',
  },
  site: 'https://taximaxim.com',
  mapConfig: {
    region: AxiomMapRegion.Global,
    [Themes.Light]: {
      trackLine: {
        color: '84, 110, 122',
      },
    },
    [Themes.Dark]: {
      trackLine: {
        color: '255, 202, 40',
      },
    },
  },
  loaderColor: '#ffc82d',
  themeable: true,
  envType: EnvType.MAXIM,
};
